module.exports = __webpack_public_path__ + "img/tie-3.fa1854cf.png";